enum MutationName {
  onboardGuestMutation = 'onboardGuest',
  signUpNewMemberMutation = 'signUpNewMember',
  createMemberAccountMutation = 'createMemberAccount',
}

export const getMutationName = (
  isSignup: boolean,
  isPayLater: boolean,
): MutationName => {
  /**
   * DTOPPOR-1480 - When using BNPL the user is required to create an account.
   * The createMemberAccount mutation is used as it does not required a payment
   * method. The payment method is added after the user is redirected to the
   * member experience.
   */
  if (isPayLater) {
    return MutationName.createMemberAccountMutation;
  }

  return isSignup
    ? MutationName.signUpNewMemberMutation
    : MutationName.onboardGuestMutation;
};
